// FROM: https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/components/DocumentSetupSecondStepBoards/index.tsx

import { Box } from '@modusign/design-system';
import { useRequester, useSigners } from '@modusign/react-signing';
import { useUIState } from '@modusign/react-signing/setup';
import { useDispatch, useSelector } from 'react-redux';

import { Viewport } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import ParticipantFieldStatusBoard, {
  SupportFieldType,
} from '@app/features/apply-react-signing/components/FieldSetupStep/ParticipantFieldStatusBoard';
import RequesterFieldsBoard from '@app/features/apply-react-signing/components/FieldSetupStep/RequesterFieldsBoard';
import { pageViewportSizesSelector } from '@app/libs/reactPdfJs/store/selectors';
import { modalOpen } from '@app/store/modal/actions';
import { ModalType } from '@app/store/modal/types';

/*
  FIXME:

    "모든 체크박스는 그룹에 속한다" 에 따라

    아래 ParticipantField의 타입에는 CheckboxField가 불필요합니다.

    [1] 에서 논의 된 것과 같이, 필드를 배치하고 카운팅을 하는데 CheckboxField 타입은 불필요합니다.

    추후에 타입을 분리하고 타입을 쉽게 추가하고 제거할 수 있도록 방향을 고민하고 수정해야 합니다.

   [1] https://github.com/modusign/modusign-client/pull/5521#discussion_r747983786

*/

interface DocumentSetupSecondStepBoardsProps {
  supportedFields: SupportFieldType[];
  isTemplateSetting: boolean;
  needAuthorityCheck: boolean;
}

// 서명요청, 템플릿에 공용으로 사용되는 컴포넌트, 네이밍 적절하게 개선 필요
function DocumentSetupSecondStepBoards({
  isTemplateSetting,
  supportedFields,
  needAuthorityCheck = false,
}: DocumentSetupSecondStepBoardsProps) {
  const dispatch = useDispatch();

  const viewports = useSelector(pageViewportSizesSelector) as Viewport[];
  const { signers } = useSigners();
  const { requester } = useRequester();
  const { ui } = useUIState();

  function handleModalOpen(modalType: ModalType, props?: { content?: string; title?: string }) {
    dispatch(modalOpen(modalType, props));
  }

  return (
    <div // eslint-disable-next-line
      className="RequestSettingPosition__joiner-card-block"
    >
      <Box mb={7}>
        {requester && <RequesterFieldsBoard requesterId={requester.id} viewports={viewports} />}
      </Box>
      {signers.map((signer, index) => {
        return (
          <ParticipantFieldStatusBoard
            index={index}
            isSigningInOrder={ui.isInOrder}
            isTemplateSetting={isTemplateSetting}
            key={signer.id}
            needAuthorityCheck={needAuthorityCheck}
            order={index + 1}
            signerId={signer.id}
            supportedFields={supportedFields}
            viewports={viewports}
            onModalOpen={handleModalOpen}
          />
        );
      })}
    </div>
  );
}

export default DocumentSetupSecondStepBoards;
